module.exports = __webpack_public_path__ + "img/sass-thumb-2.2041f87f.png";